<h1>Enroll</h1>

@if (sub.maxAllowedUniqueDealerTechnicianLogins > 0) {
  <section>
    <p>Clicking "Enroll Now" below will subscribe you to the Ford Diagnostic Enrollment Program.
      <ul>
        <li>PA Code: {{sub.siteCode}}
          <li>Number of Service Technicians: {{sub.maxAllowedUniqueDealerTechnicianLogins.toLocaleString()}}
            <li>Yearly Cost Per Technician: ${{prices.per_tech.toLocaleString(undefined, {minimumFractionDigits: 2})}}
              <li>Monthly Total Cos: ${{prices.monthly.toLocaleString(undefined, {minimumFractionDigits: 2})}}
                <li>Each Technician may be logged into {{sub.concurrentSessions.toLocaleString()}} instances of software at one time.
                  <li>Total allowable active sessions in your dealership is {{(sub.maxAllowedUniqueDealerTechnicianLogins * sub.concurrentSessions).toLocaleString()}} maximum. (If a tech is working on multiple vehicles.)
                  </ul>
                  <p><button (click)="addSubscription()">Enroll Now</button>
                </section>
              }

              @if (!sub.maxAllowedUniqueDealerTechnicianLogins) {
                <section>
                  <h3>No Technicians Found</h3>
                  <p>Please <a href="/contact">contact us</a> to set the number of service technicians needed to access the IDS system.
                </section>
              }
